import Clear from './../layouts/Clear.vue';

export default {
  path: '/registrationArea',
  component: Clear,
  children: [
    {
      path: '',
      name: 'registrationArea.index',
      component: () => import('@/views/registrationArea/index.vue'),
    },
  ],
};
